'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.countdown = twentyninetimes.countdown || function () {

	function init() {
        var countdownElm = document.getElementById('js-countdown');

        if ( !countdownElm ) return;

        var endDate = countdownElm.getAttribute('data-end-date');

        if ( !endDate ) return;

        var lang = countdownElm.getAttribute('data-lang');

        endDate = new Date(endDate);

        const message = ' ';
		countdownFunction(countdownElm, endDate, message, 'dHMS', null, 1000, lang);
	}

    // Function to build a countdown timer
    // Usage:
    // 1. Include this script in your HTML page
    // 2. Call the function with the following parameters:
    //    - id: the id of the element where the countdown will be displayed
    //    - date: the date to count down to
    //    - message: the message to display when the countdown is over
    //    - format: the format of the countdown (default: 'dHMS')
    //    - callback: a function to call when the countdown is over (default: null)
    //    - interval: the interval between each countdown update (default: 1000)
    //    - lang: the language of the countdown (default: 'en')
    //    - langData: the language data of the countdown (default: null)

    function countdownFunction(el, date, message, format, callback, interval, lang, langData) {
        // Set default values
        format = typeof format !== 'undefined' ? format : 'dHMS';
        callback = typeof callback !== 'undefined' ? callback : null;
        interval = typeof interval !== 'undefined' ? interval : 1000;
        lang = typeof lang !== 'undefined' ? lang : 'en';
        langData = typeof langData !== 'undefined' ? langData : null;

        // If the element doesn't exist, stop the function
        if (!el) {
            return;
        }

        // If the language data is not set, set it to the default language data
        if (!langData) {
            langData = {
                'en': {
                    'days': 'days',
                    'hours': 'hours',
                    'minutes': 'minutes',
                    'seconds': 'seconds'
                },
                'fr': {
                    'days': 'jours',
                    'hours': 'heures',
                    'minutes': 'minutes',
                    'seconds': 'secondes'
                },
                'da': {
                    'days': 'dage',
                    'hours': 'timer',
                    'minutes': 'minutter',
                    'seconds': 'sekunder'
                },
            };
        }

        // If the language is not supported, stop the function
        if (!langData[lang]) {
            return;
        }

        // If the format is not supported, stop the function
        if (format != 'dHMS' && format != 'HMS') {
            return;
        }

        // If the date is not set, stop the function
        if (!date) {
            return;
        }

        // If the date is not a Date object, stop the function
        if (!(date instanceof Date)) {
            return;
        }

        // If the date is in the past, stop the function
        if (date < new Date()) {
            return;
        }

        // If the message is not set, stop the function
        if (!message) {
            return;
        }

        // If the message is not a string, stop the function
        if (typeof message != 'string') {
            return;
        }

        // If the interval is not set, stop the function
        if (!interval) {
            return;
        }

        // If the interval is not a number, stop the function
        if (typeof interval != 'number') {
            return;
        }

        // If the interval is not greater than 0, stop the function
        if (interval <= 0) {
            return;
        }

        // Update the countdown every second
        var update = setInterval(function() {

            // Get the current date
            var now = new Date();

            // Get the difference between the current date and the date to count down to
            var difference = date.getTime() - now.getTime();

            // If the difference is less than 0, stop the function
            if (difference < 0) {
                // Stop the countdown
                clearInterval(update);

                // Display the message
                //el.innerHTML = message;

                // Call the callback function
                if (callback) {
                    callback();
                }

                // Stop the function
                return;
            }

            // Calculate the number of days
            var days = Math.floor(difference / (1000 * 60 * 60 * 24));

            // Calculate the number of hours
            var hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

            // Calculate the number of minutes
            var minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));

            // Calculate the number of seconds
            var seconds = Math.floor((difference % (1000 * 60)) / 1000);

            // If the format is 'dHMS', display the number of days
            if (format == 'dHMS') {
                // Display the number of days
                el.innerHTML = 
                    '<div class="count-group"><span class="count-group__value">' + ('0' + days).slice(-2) + '</span><span class="count-group__label">' + langData[lang]['days'] + '</span></div>' + 
                    '<div class="count-group"><span class="count-group__value">' + ('0' + hours).slice(-2) + '</span><span class="count-group__label">' + langData[lang]['hours'] + '</span></div>' + 
                    '<div class="count-group"><span class="count-group__value">' + ('0' + minutes).slice(-2) + '</span><span class="count-group__label">' + langData[lang]['minutes'] + '</span></div>' + 
                    '<div class="count-group"><span class="count-group__value">' + ('0' + seconds).slice(-2) + '</span><span class="count-group__label">' + langData[lang]['seconds'] + '</span></div>';
            }

            // If the format is 'HMS', display the number of hours
            if (format == 'HMS') {
                // Display the number of hours
                el.innerHTML = 
                    '<div class="count-group"><span class="count-group__value">' + ('0' + days).slice(-2) + '</span><span class="count-group__label">' + langData[lang]['hours'] + '</span></div>' + 
                    '<div class="count-group"><span class="count-group__value">' + ('0' + minutes).slice(-2) + '</span><span class="count-group__label">' + langData[lang]['minutes'] + '</span></div>' + 
                    '<div class="count-group"><span class="count-group__value">' + ('0' + seconds).slice(-2) + '</span><span class="count-group__label">' + langData[lang]['seconds'] + '</span></div>';
            }

            setTimeout(() => {
                if ( !el.classList.contains('loaded') ) el.classList.add('loaded');
            }, 100);

        }
        , interval);
    }


    return {
		init : init
	};

}();
